import LocalizedStrings from 'react-localization';

const tenantManagementStrings = new LocalizedStrings({
  en: {
    tenantInfoTablesSection: {
      title: 'Tenant Management',
      idColumn: 'Tenant ID',
      nameColumn: 'Tenant Name',
      databaseNameColumn: 'Database Name',
      isActiveColumn: 'Active',

      // Added for TenantGrid
      addButton: '+ Add',
      namePlaceholder: 'Enter tenant name',
      databaseNamePlaceholder: 'Enter database name',
      delegationColumn: 'Settings',
      settingsColumn: 'SuperAdmin Settings',
      enterDelegation: 'Admin Settings',
      enterSettings: 'SuperAdmin Settings'
    },
    apiResults: {
      createSuccess: (tenantName: string) => `Tenant "${tenantName}" created successfully`,
      updateSuccess: (tenantName: string) => `Tenant "${tenantName}" updated successfully`,
      deleteSuccess: (tenantName: string) => `Tenant "${tenantName}" deleted successfully`,
      saveError: (tenantName: string) => `Save failed for tenant "${tenantName}"`,
      deleteError: (tenantName: string) => `Delete failed for tenant "${tenantName}"`,
      loadError: 'Failed to load tenants'
    },
    saveModal: {
      title: 'Create Tenant',
      message: (tenantName: string) => `Register tenant "${tenantName}" and create its database.`,
      cancel: 'Cancel',
      confirm: 'Create'
    },
    deleteModal: {
      title: 'Delete Tenant',
      message: (tenantName: string) => `Are you sure you want to delete tenant "${tenantName}"?`,
      cancel: 'Cancel',
      confirm: 'Delete'
    },
    delegationBar: {
      actingAs: (tenantName: string) => `Editing admin settings for tenant: ${tenantName}`,
      unknownTenant: 'Unknown Tenant',
      exit: 'Exit Settings'
    },
    locationMimicBar: {
      editingLocation: (locationName: string) => `Editing as location manager for: ${locationName}`,
      exit: 'Exit Location Mode'
    },
    tenantSettingsBar: {
      editingTenant: (tenantName: string) => `Editing SuperAdmin settings for tenant: ${tenantName}`,
      exit: 'Exit Settings'
    },
    corsOrigins: {
      title: 'Allowed CORS Origins',
      originColumn: 'Origin URL',
      placeholder: 'https://example.com',
      addButton: 'Add',

      loadError: 'Failed to load CORS origins',
      addSuccess: 'CORS origin added',
      addError: 'Failed to add CORS origin',
      deleteSuccess: 'CORS origin deleted',
      deleteError: 'Failed to delete CORS origin',

      deleteModalTitle: 'Delete Allowed Origin',
      deleteConfirm: 'Delete',
      deleteCancel: 'Cancel'
    }
  }
});

export default tenantManagementStrings;
